import { messaging, db } from "@/plugins/firebase"
let id = 0;

const state = {
    notifications: []
}
const mutations = {
    ADD_NOTIFICATION: function (state, notification) {
        state.notifications = [...state.notifications, notification]
    },
    SET_NOTIFICATIONS: function (state, notifications){
        state.notifications = [...notifications]
    }
}
const actions = {
    setMessagingToken: async function ({ rootState }) {
        try {
            let token = await messaging.getToken();
            if (!token) {
                await db.collection("users").doc(rootState.db.user.id).collection("data").doc("private").update({
                    messagingToken: false
                })
            }
            else if (token !== rootState.db.privateUser.messagingToken) {
                await db.collection("users").doc(rootState.db.user.id).collection("data").doc("private").update({
                    messagingToken: token
                })
            }
        } catch (err) {
            console.log('An error occurred while retrieving the messaging token. ', err);
        }
    },
    listenForTokenRefresh: function ({ dispatch }) {
        messaging.onTokenRefresh(() => {
            dispatch("setMessagingToken");
        });
    },
    listenForNotification: function ({ commit }) {
        // Handle incoming messages. Called when:
        // - a message is received while the app has focus
        // - the user clicks on an app notification created by a service worker
        //   `messaging.setBackgroundMessageHandler` handler.
        messaging.onMessage((payload) => {
            console.log('Message received. ', payload);
            commit("ADD_NOTIFICATION", {id, ...payload});
            id += 1;
        });
    },
    removeNotification: function({ commit, state }, notification){
        let notifications = state.notifications.filter(n => n.id !== notification.id);
        commit("SET_NOTIFICATIONS", notifications);
    }
}
const getters = {

}

export default {
    state,
    mutations,
    actions,
    getters
}